/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.buttongroup[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%], .smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-top:15px}.smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-bottom:10px}.error[_ngcontent-%COMP%]{color:red}.actionbar[_ngcontent-%COMP%]{margin-top:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/collegestudentsearch/collegestudentsearch.component.css.shim.ngstyle.js.pre-build-optimizer.js